var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:[_vm.$style.button, _setup.isFollowed && _vm.$style.isFollowed, _vm.small && _vm.$style.small],on:{"click":_setup.onClick}},[(_setup.isFollowed)?_c('span',[_vm._v("お気に入りに追加済")]):_c('span',[_vm._v("お気に入りショップに追加")])])
}
var staticRenderFns = []

export { render, staticRenderFns }